/* =============================================================================
 * GPA — one spelling, everywhere
 * -----------------------------------------------------------------------------
 * The same athlete used to have three GPAs in the product: "3.60" on the coach
 * profile, "3.6" on the public share page, and "3.6" again (via toString) on
 * the family's own profile — with a flat 4.0 printing as bare "4". A coach and
 * a family comparing screens read those as different numbers.
 *
 * Two decimals is the spelling every other GPA surface already used (the grid
 * card, the fit explanation, the CSV), so it is the one that wins. Every place
 * that prints a GPA calls this; nothing formats a GPA inline.
 * ========================================================================== */

/**
 * "3.60", "4.00", "2.85". Returns '' for a missing GPA so callers can fall back
 * to their own "not provided" copy, and passes a non-numeric value through
 * untouched rather than printing NaN.
 */
export function formatGpa(gpa: number | string | null | undefined): string {
  if (gpa === null || gpa === undefined || gpa === '') return '';
  const n = typeof gpa === 'number' ? gpa : Number(gpa);
  return Number.isFinite(n) ? n.toFixed(2) : String(gpa);
}

export default formatGpa;
